import * as React from 'react'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Container from '@mui/material/Container'
import logo from '../assets/logo-devis-app.png'
import logoXs from '../assets/logo-xs.png'
import '../styles/navbar.css'

export default function Navbar() {
  return (
    <AppBar position="static" sx={{ bgcolor: '#FAF9F6', width: '98%', margin: '25px auto', borderRadius: '40px' }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
            <img src={logo} alt='logo' className='logo' style={{ width: '200px', mr: 1 }} />
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}></Box>
          <img src={logoXs} alt='logo' className='logo-invert' />
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}></Box>
        </Toolbar>
      </Container>
    </AppBar>
  )
}
